module.exports = __webpack_public_path__ + "img/home-nonconformities.b289b4b2.svg";